import {
  recordSuppressedError,
  SuppressedErrorReason,
} from '~/utils/suppressedErrorTelemetry';

const REPORTED_ELEMENTS = ['SCRIPT', 'LINK', 'IMG'];

function describeElement(element: Element) {
  if (element instanceof HTMLScriptElement) return element.src;
  if (element instanceof HTMLLinkElement) return element.href;
  if (element instanceof HTMLImageElement) return element.src;
  return 'unknown';
}

export function startAssetFailureReporting() {
  // Element load errors do not bubble, so only a capture-phase listener sees them.
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!REPORTED_ELEMENTS.includes(target.tagName)) return;

      recordSuppressedError(SuppressedErrorReason.ResourceLoadError, {
        element: target.tagName.toLowerCase(),
        url: describeElement(target),
      });
    },
    true,
  );

  document.addEventListener('securitypolicyviolation', (event) => {
    recordSuppressedError(SuppressedErrorReason.CspViolation, {
      url: event.blockedURI,
      directive: event.effectiveDirective,
      policy: event.originalPolicy,
      disposition: event.disposition,
    });
  });
}
